import { MutationTree, ActionTree, Module } from "vuex";
import {
  CHANGE_CURRENT_STEP_4_INDIVIDUAL,
  CHANGE_CURRENT_STEP_4_INSTITUTION,
  CHANGE_ACCOUNT_EMAIL,
  CHANGE_APPLY_TYPE,
  SET_INSTITUTION_PERCENT_LIST
} from "./mutation-types";

interface Step {
  view: string;
  status: string;
  title: string;
  valid: boolean;
  percent?: number;
}

interface State {
  applyType: number;
  enableVeriff4Individual: boolean;
  enableVeriff4Institution: boolean;
  currentStep4Individual: number;
  currentStep4Institution: number;
  accountEmail: string;
  kycStepLists4Individual: Step[];
  kycStepLists4Institution: Step[];
  institutionPercentList: number[];
}

// inital state
const state: () => State = () => ({
  applyType: -1, //-1 无类型 0 个人 1 公司
  enableVeriff4Individual: true,
  enableVeriff4Institution: false,
  currentStep4Individual: 0,
  currentStep4Institution: 0,
  accountEmail: "",
  kycStepLists4Individual: [
    {
      view: "PersonalInfo",
      status: "process",
      title: "Personal Info",
      valid: false
    },
    {
      view: "BankingInfo",
      status: "wait",
      title: "Banking Info",
      valid: false
    },
    {
      view: "Questionnaire",
      status: "wait",
      title: "Questionnaire",
      valid: false
    },
    {
      view: "Identification",
      status: "wait",
      title: "Identification",
      valid: false
    }
  ],
  kycStepLists4Institution: [
    {
      view: "GeneralInfo",
      status: "process",
      title: "General",
      valid: false,
      percent: 16
    },
    {
      view: "Documents",
      status: "wait",
      title: "Documentation",
      valid: false,
      percent: 32
    },
    {
      view: "BankingInfo",
      status: "wait",
      title: "Banking Info",
      valid: false,
      percent: 48
    },
    {
      view: "Questionnaire",
      status: "wait",
      title: "Questionnaire",
      valid: false,
      percent: 64
    },
    {
      view: "Representives",
      status: "wait",
      title: "Representives",
      valid: false,
      percent: 80
    },
    {
      view: "BeneficialOwners",
      status: "wait",
      title: "Beneficial Owners",
      valid: false,
      percent: 100
    }
  ],
  institutionPercentList: []
});

// getters
const getters = {};

// actions
const actions = <ActionTree<State, any>>{
  changeCurrentStep4Individual({ commit }, stepData) {
    commit(CHANGE_CURRENT_STEP_4_INDIVIDUAL, stepData);
  },
  changeCurrentStep4Institution({ commit }, stepData) {
    commit(SET_INSTITUTION_PERCENT_LIST, stepData);
    commit(CHANGE_CURRENT_STEP_4_INSTITUTION, stepData);
  },
  changeAccountEmail({ commit }, accountEmail) {
    commit(CHANGE_ACCOUNT_EMAIL, accountEmail);
  },
  changeApplyType({ commit }, applyType) {
    commit(CHANGE_APPLY_TYPE, applyType);
  }
};

// mutations
const mutations = <MutationTree<State>>{
  [CHANGE_APPLY_TYPE](state, applyType) {
    state.applyType = applyType;
  },
  [CHANGE_CURRENT_STEP_4_INDIVIDUAL](state, stepData) {
    if (state.currentStep4Individual > stepData) {
      // 说明是后退的操作
      state.kycStepLists4Individual[state.currentStep4Individual].status =
        "wait";
      state.kycStepLists4Individual[stepData].status = "process";
    } else {
      // 说明是前进的操作
      state.kycStepLists4Individual[state.currentStep4Individual].status =
        "finish";
      state.kycStepLists4Individual[stepData].status = "process";
    }
    state.currentStep4Individual = stepData;
  },
  [CHANGE_CURRENT_STEP_4_INSTITUTION](state, stepData) {
    if (state.currentStep4Institution > stepData) {
      // 说明是后退的操作
      state.kycStepLists4Institution[state.currentStep4Institution].status =
        "wait";
      state.kycStepLists4Institution[stepData].status = "process";
    } else {
      // 说明是前进的操作
      state.kycStepLists4Institution[state.currentStep4Institution].status =
        "finish";
      const setData = new Set<number>();
      const percent =
        state.kycStepLists4Institution[state.currentStep4Institution].percent;
      setData.add(percent ?? 0);
      state.institutionPercentList = Array.from(setData);
      state.kycStepLists4Institution[stepData].status = "process";
    }
    state.currentStep4Institution = stepData;
  },
  [CHANGE_ACCOUNT_EMAIL](state, accountEmail) {
    state.accountEmail = accountEmail;
  }
};

const KYC = <Module<State, any>>{
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default KYC;
